import networkSvc from './networkSvc';

export default {
  async createShare(content, name) {
    const response = await networkSvc.request({
      method: 'POST',
      url: 'share',
      body: { content, name },
    });
    const { origin, pathname } = window.location;
    // pathname is e.g. "/app" – keep it as the base
    return `${origin}${pathname}?share=${response.body.id}`;
  },

  async getShare(id) {
    const response = await networkSvc.request({
      method: 'GET',
      url: `share/${id}`,
    });
    return response.body; // { content, name }
  },
};



// WEBPACK FOOTER //
// ./src/services/shareSvc.js